import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"

export type UseSEOOptions = {
  interpolations: Interpolations
}

export const useSEO = ({ interpolations }: UseSEOOptions) => {
  const { t } = useTranslation("marketing-ls-store")

  return {
    metaTitle: t(
      "screen.storeScreen.metaTitleV2",
      "Luggage Storage 24/7 {{STORE_NAME}} | Better Than Lockers",
      interpolations,
    ),
    metaDescription: t(
      "screen.storeScreen.metaDescription",
      "Keep your stuff safe at {{STORE_NAME}} with Bounce: your convenient and affordable luggage storage go-to.",
      interpolations,
    ),
  }
}
